import { render, staticRenderFns } from "./index.vue?vue&type=template&id=96bcf5c4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=96bcf5c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bcf5c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96bcf5c4')) {
      api.createRecord('96bcf5c4', component.options)
    } else {
      api.reload('96bcf5c4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=96bcf5c4&scoped=true", function () {
      api.rerender('96bcf5c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/statistics/add-statistics/index.vue"
export default component.exports